export const getMaxHeight = (banners) => {
    let maxBanner = banners[0];
    banners.forEach(ele => {
        if (+((ele === null || ele === void 0 ? void 0 : ele.height) || "") > +((maxBanner === null || maxBanner === void 0 ? void 0 : maxBanner.height) || "")) {
            maxBanner = ele;
        }
    });
    return (1200 * +(maxBanner.height || "")) / +((maxBanner === null || maxBanner === void 0 ? void 0 : maxBanner.width) || "");
};
